export default __webpack_public_path__ + "static/media/Email_qr_icon.5faa5d66.svg";